export interface IParcelStockoutResponseProductEntry {
    productId: number;
    quantity: number;
}

export class ParcelStockoutResponseProductEntry {
    private readonly _productId: number;
    private readonly _quantity: number;

    constructor(data: IParcelStockoutResponseProductEntry) {
        this._productId = data.productId;
        this._quantity = data.quantity;
    }

    get productId(): number {
        return this._productId;
    }

    get quantity(): number {
        return this._quantity;
    }
}
